export default "__VITE_ASSET__7136c8c3__"